package com.example.readingnotes.domain.model

import kotlinx.datetime.Instant

data class Notification(
    val id: String,
    val type: NotificationType,
    val title: String,
    val body: String,
    val data: String? = null,
    val isRead: Boolean,
    val relatedPostId: String? = null,
    val relatedCommentId: String? = null,
    val createdAt: Instant,
    val readAt: Instant? = null,
)

enum class NotificationType {
    NEW_POST,
    NEW_COMMENT,
    COMMENT_REPLY,
    MENTION,
    SYSTEM,
}

fun String.toNotificationType(): NotificationType =
    when (this) {
        "new_post" -> NotificationType.NEW_POST
        "new_comment" -> NotificationType.NEW_COMMENT
        "comment_reply" -> NotificationType.COMMENT_REPLY
        "mention" -> NotificationType.MENTION
        "system" -> NotificationType.SYSTEM
        else -> NotificationType.SYSTEM
    }

fun NotificationType.toStringValue(): String =
    when (this) {
        NotificationType.NEW_POST -> "new_post"
        NotificationType.NEW_COMMENT -> "new_comment"
        NotificationType.COMMENT_REPLY -> "comment_reply"
        NotificationType.MENTION -> "mention"
        NotificationType.SYSTEM -> "system"
    }

data class NotificationSettings(
    val enableNewPost: Boolean = true,
    val enableNewComment: Boolean = true,
    val enableCommentReply: Boolean = true,
    val enableMention: Boolean = true,
    val enableSystem: Boolean = true,
    val muteStart: String? = null, // HH:mm format
    val muteEnd: String? = null, // HH:mm format
)

data class PaginatedNotifications(
    val notifications: List<Notification>,
    val total: Int,
    val limit: Int,
    val offset: Int,
    val hasMore: Boolean,
)
